import { EmergencyPowerSettingsDto } from 'src/Libs/emergency-power/api'
import { EmergencyPowerSettingsModel } from 'src/Libs/emergency-power'

const fromDtoToModelTransformer = (dto: EmergencyPowerSettingsDto): EmergencyPowerSettingsModel => ({
  ...dto,
  emsIsPossible: dto.emsIsPossible ?? false,
  isChargeLockActive: dto.isChargeLockActive ?? false,
  isDischargeLockActive: dto.isDischargeLockActive ?? false,
  deviceState: {
    working: dto.deviceState?.deviceWorking ?? false,
    inService: dto.deviceState?.deviceInService ?? false,
    connected: dto.deviceState?.deviceConnected ?? false,
  },
})

export default fromDtoToModelTransformer
